import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import InstallerApp from './pages/InstallerApp';
import { AuthContext } from './context/AuthContext';
import './App.css';

// ── Página de callback tras OAuth de Facebook ─────────────────────────────────

function FacebookCallbackPage() {
  const params    = new URLSearchParams(window.location.search);
  const connected = params.get('fb_connected');
  const pages     = params.get('fb_pages');
  const error     = params.get('fb_error');
  const fbSelect  = params.get('fb_select');

  // Guardar resultado en sessionStorage para que AjustesPage lo lea
  useEffect(() => {
    if (fbSelect) {
      // Nuevo flujo: guardar clave y redirigir al CRM para mostrar el selector
      sessionStorage.setItem('fb_select_key', fbSelect);
      window.location.href = '/';
      return;
    }
    if (connected) sessionStorage.setItem('fb_just_connected', connected);
    if (error)     sessionStorage.setItem('fb_just_error', error);
  }, [connected, error, fbSelect]);

  // Si hay fb_select, mostrar pantalla de carga mientras redirige
  if (fbSelect) {
    return (
      <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#f8fafc' }}>
        <p style={{ color:'#64748b', fontSize:15 }}>Cargando selector de formularios…</p>
      </div>
    );
  }

  const ok = !error && connected !== null;

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#f8fafc', fontFamily: 'inherit',
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: '40px 48px', textAlign: 'center',
        boxShadow: '0 4px 24px rgba(0,0,0,.08)', maxWidth: 420, width: '100%',
      }}>
        {ok ? (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h2 style={{ margin: '0 0 8px', color: '#15803d', fontSize: 20 }}>
              ¡Conexión completada!
            </h2>
            <p style={{ color: '#64748b', margin: '0 0 28px', fontSize: 14 }}>
              <strong>{pages} página{pages !== '1' ? 's' : ''} conectada{pages !== '1' ? 's' : ''}</strong> con <strong>{connected}</strong> formulario{connected !== '1' ? 's' : ''}. Los leads de tus formularios llegarán automáticamente al CRM.
            </p>
          </>
        ) : (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>❌</div>
            <h2 style={{ margin: '0 0 8px', color: '#dc2626', fontSize: 20 }}>
              Error en la conexión
            </h2>
            <p style={{ color: '#64748b', margin: '0 0 28px', fontSize: 14 }}>
              {decodeURIComponent(error || 'Error desconocido')}
            </p>
          </>
        )}
        <a
          href="/"
          style={{
            display: 'inline-block', background: '#3b82f6', color: '#fff',
            padding: '10px 28px', borderRadius: 8, textDecoration: 'none',
            fontWeight: 600, fontSize: 14,
          }}
        >
          Ir a Ajustes
        </a>
      </div>
    </div>
  );
}

// ── Estilos compartidos páginas legales (diseño oscuro) ───────────────────────

const S = {
  page:  { minHeight: '100vh', background: '#0F1117', padding: '48px 16px', fontFamily: "'DM Sans', sans-serif" },
  wrap:  { maxWidth: 720, margin: '0 auto' },
  brand: { marginBottom: '2.5rem' },
  brandName: { fontFamily: "'DM Sans', sans-serif", fontWeight: 300, fontSize: 24, letterSpacing: '-1px', color: '#fff', lineHeight: 1 },
  brandG: { color: '#E84300' },
  card:  { background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 16, padding: '40px 48px' },
  h1:    { fontFamily: "'DM Sans', sans-serif", fontWeight: 300, fontSize: 26, letterSpacing: '-1px', color: '#fff', margin: '0 0 4px' },
  meta:  { fontSize: 12, color: 'rgba(255,255,255,0.3)', margin: '0 0 32px', display: 'block', letterSpacing: '2px', textTransform: 'uppercase' },
  h2:    { fontFamily: "'DM Sans', sans-serif", fontWeight: 400, fontSize: 13, color: '#E84300', margin: '28px 0 8px', letterSpacing: '1px', textTransform: 'uppercase' },
  p:     { fontSize: 14, color: 'rgba(255,255,255,0.6)', lineHeight: 1.8, margin: '0 0 10px' },
  ul:    { fontSize: 14, color: 'rgba(255,255,255,0.6)', lineHeight: 1.8, paddingLeft: 18, margin: '0 0 10px' },
  link:  { color: '#E84300' },
  back:  { display: 'inline-block', marginTop: 36, color: 'rgba(255,255,255,0.4)', fontSize: 13, textDecoration: 'none' },
  foot:  { marginTop: 32, fontSize: 12, color: 'rgba(255,255,255,0.2)', borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: 20 },
};

function LegalBrand() {
  return (
    <div style={S.brand}>
      <span style={S.brandName}><span style={S.brandG}>g</span>estavin</span>
    </div>
  );
}

// ── Política de Privacidad ─────────────────────────────────────────────────────

function PrivacyPage() {
  return (
    <div style={S.page}>
      <div style={S.wrap}>
        <LegalBrand />
        <div style={S.card}>
          <h1 style={S.h1}>Política de Privacidad</h1>
          <span style={S.meta}>BTOOLIN CONNECT S.L. — gestavin.com · Última actualización: marzo de 2026</span>

          <h2 style={S.h2}>1. Responsable del tratamiento</h2>
          <p style={S.p}><strong style={{color:'rgba(255,255,255,0.85)'}}>Razón social:</strong> BTOOLIN CONNECT S.L.</p>
          <p style={S.p}><strong style={{color:'rgba(255,255,255,0.85)'}}>Nombre comercial:</strong> Gestavin</p>
          <p style={S.p}><strong style={{color:'rgba(255,255,255,0.85)'}}>Sitio web:</strong> https://gestavin.com</p>
          <p style={S.p}><strong style={{color:'rgba(255,255,255,0.85)'}}>Correo electrónico:</strong> info@gestavin.com</p>

          <h2 style={S.h2}>2. Datos que recopilamos</h2>
          <p style={S.p}>Recopilamos los siguientes datos personales:</p>
          <ul style={S.ul}>
            <li>Nombre y apellidos</li>
            <li>Dirección de correo electrónico</li>
            <li>Número de teléfono</li>
            <li>Nombre de empresa y CIF/NIF</li>
            <li>Datos de campañas publicitarias de Facebook Ads (nombre, email, teléfono del lead)</li>
            <li>Dirección IP y datos de navegación</li>
          </ul>

          <h2 style={S.h2}>3. Finalidad del tratamiento</h2>
          <ul style={S.ul}>
            <li>Gestión de clientes potenciales (leads) a través de nuestra plataforma CRM</li>
            <li>Prestación del servicio SaaS contratado</li>
            <li>Comunicaciones comerciales y de soporte</li>
            <li>Integración con plataformas de publicidad como Facebook Ads</li>
            <li>Facturación y gestión administrativa</li>
          </ul>

          <h2 style={S.h2}>4. Base jurídica</h2>
          <ul style={S.ul}>
            <li>Ejecución de un contrato (art. 6.1.b RGPD)</li>
            <li>Consentimiento del interesado (art. 6.1.a RGPD)</li>
            <li>Interés legítimo del responsable (art. 6.1.f RGPD)</li>
          </ul>

          <h2 style={S.h2}>5. Destinatarios de los datos</h2>
          <ul style={S.ul}>
            <li>Meta Platforms Ireland Ltd. (Facebook/Instagram) para la gestión de campañas publicitarias</li>
            <li>Proveedores de servicios de alojamiento web (Hostinger)</li>
            <li>Proveedores de servicios de pago</li>
            <li>Administraciones públicas cuando sea legalmente requerido</li>
          </ul>

          <h2 style={S.h2}>6. Transferencias internacionales</h2>
          <p style={S.p}>Sus datos pueden ser transferidos a países fuera del Espacio Económico Europeo, concretamente a Meta Platforms Inc. (Estados Unidos), bajo las garantías adecuadas establecidas por la Comisión Europea (Decisión de adecuación o Cláusulas Contractuales Tipo).</p>

          <h2 style={S.h2}>7. Plazo de conservación</h2>
          <p style={S.p}>Conservaremos sus datos durante el tiempo necesario para la prestación del servicio y, posteriormente, durante los plazos legalmente establecidos (máximo 5 años para datos fiscales y contractuales).</p>

          <h2 style={S.h2}>8. Derechos del interesado</h2>
          <p style={S.p}>Puede ejercer los siguientes derechos enviando un email a <strong style={{color:'rgba(255,255,255,0.85)'}}>info@gestavin.com</strong>:</p>
          <ul style={S.ul}>
            <li>Derecho de acceso a sus datos personales</li>
            <li>Derecho de rectificación de datos inexactos</li>
            <li>Derecho de supresión (derecho al olvido)</li>
            <li>Derecho a la limitación del tratamiento</li>
            <li>Derecho a la portabilidad de los datos</li>
            <li>Derecho de oposición al tratamiento</li>
            <li>Derecho a no ser objeto de decisiones automatizadas</li>
          </ul>
          <p style={S.p}>Junto a su solicitud deberá adjuntar una copia de su DNI o documento identificativo equivalente. Responderemos en un plazo máximo de 30 días.</p>

          <h2 style={S.h2}>9. Reclamaciones</h2>
          <p style={S.p}>Si considera que el tratamiento de sus datos no es adecuado, puede presentar una reclamación ante la Autoridad de Control española: <strong style={{color:'rgba(255,255,255,0.85)'}}>Agencia Española de Protección de Datos (AEPD)</strong> — www.aepd.es</p>

          <h2 style={S.h2}>10. Cookies</h2>
          <p style={S.p}>Utilizamos cookies técnicas necesarias para el funcionamiento de la plataforma. No utilizamos cookies de seguimiento o publicidad sin su consentimiento previo.</p>

          <h2 style={S.h2}>11. Cambios en la política</h2>
          <p style={S.p}>Nos reservamos el derecho de modificar esta política. Le notificaremos cualquier cambio relevante por correo electrónico o mediante aviso en la plataforma.</p>

          <p style={S.foot}>BTOOLIN CONNECT S.L. · info@gestavin.com · gestavin.com</p>
        </div>
        <div style={{display:'flex', gap:'1.5rem', marginTop:24}}>
          <a href="/" style={S.back}>← Volver al inicio</a>
          <a href="/data-deletion" style={S.back}>Eliminación de datos →</a>
        </div>
      </div>
    </div>
  );
}

// ── Eliminación de datos ───────────────────────────────────────────────────────

function DataDeletionPage() {
  return (
    <div style={S.page}>
      <div style={S.wrap}>
        <LegalBrand />
        <div style={S.card}>
          <h1 style={S.h1}>Eliminación de datos</h1>
          <span style={S.meta}>BTOOLIN CONNECT S.L. — gestavin.com</span>

          <p style={S.p}>Para solicitar la eliminación completa de sus datos personales de la plataforma Gestavin, envíe un correo electrónico a <strong style={{color:'rgba(255,255,255,0.85)'}}>info@gestavin.com</strong> indicando en el asunto: <strong style={{color:'#E84300'}}>"SOLICITUD DE ELIMINACIÓN DE DATOS"</strong>.</p>

          <h2 style={S.h2}>En el correo incluya</h2>
          <ul style={S.ul}>
            <li>Nombre completo</li>
            <li>Email con el que está registrado</li>
            <li>Una copia de su documento de identidad (DNI/NIE/Pasaporte)</li>
          </ul>

          <h2 style={S.h2}>Plazo de respuesta</h2>
          <p style={S.p}>Procesaremos su solicitud en un plazo máximo de <strong style={{color:'rgba(255,255,255,0.85)'}}>30 días</strong> y le confirmaremos por email cuando sus datos hayan sido eliminados completamente de nuestros sistemas.</p>

          <p style={S.foot}>BTOOLIN CONNECT S.L. · info@gestavin.com</p>
        </div>
        <div style={{display:'flex', gap:'1.5rem', marginTop:24}}>
          <a href="/" style={S.back}>← Volver al inicio</a>
          <a href="/privacy" style={S.back}>Política de privacidad →</a>
        </div>
      </div>
    </div>
  );
}

// ── Condiciones de uso ────────────────────────────────────────────────────────

function TermsPage() {
  return (
    <div style={S.page}>
      <div style={S.wrap}>
        <LegalBrand />
        <div style={S.card}>
          <h1 style={S.h1}>Condiciones de Uso</h1>
          <span style={S.meta}>BTOOLIN CONNECT S.L. — gestavin.com · Última actualización: marzo de 2026</span>

          <h2 style={S.h2}>1. Objeto y aceptación</h2>
          <p style={S.p}>Las presentes Condiciones de Uso regulan el acceso y la utilización de la plataforma Gestavin (en adelante, "el Servicio"), titularidad de BTOOLIN CONNECT S.L., con correo electrónico de contacto <strong style={{color:'rgba(255,255,255,0.85)'}}>info@gestavin.com</strong>. El acceso y uso del Servicio implica la aceptación plena de estas condiciones.</p>

          <h2 style={S.h2}>2. Descripción del Servicio</h2>
          <p style={S.p}>Gestavin es una plataforma SaaS (Software as a Service) de gestión empresarial modular que incluye funcionalidades de CRM, gestión de leads, presupuestos, facturación y automatización de campañas publicitarias. El Servicio se presta bajo modalidad de suscripción.</p>

          <h2 style={S.h2}>3. Condiciones de acceso</h2>
          <p style={S.p}>Para acceder al Servicio es necesario ser mayor de 18 años, actuar en nombre de una empresa o actividad profesional, y disponer de las credenciales de acceso proporcionadas por el administrador de su cuenta. Queda prohibido ceder las credenciales de acceso a terceros.</p>

          <h2 style={S.h2}>4. Obligaciones del usuario</h2>
          <p style={S.p}>El usuario se compromete a utilizar el Servicio de conformidad con la ley, la moral y el orden público. Queda expresamente prohibido utilizar el Servicio para almacenar datos personales sin el consentimiento de los interesados, enviar comunicaciones comerciales no solicitadas, o realizar cualquier actividad que pueda dañar los sistemas o la reputación de BTOOLIN CONNECT S.L.</p>

          <h2 style={S.h2}>5. Integración con Facebook/Meta</h2>
          <p style={S.p}>El Servicio puede integrarse con las plataformas de Meta (Facebook, Instagram) para la gestión de campañas publicitarias y captación de leads. El usuario es responsable de cumplir con las Políticas de uso de Meta y de obtener los consentimientos necesarios de los usuarios finales cuyos datos se capturen a través de formularios de Facebook Lead Ads.</p>

          <h2 style={S.h2}>6. Propiedad intelectual</h2>
          <p style={S.p}>Todos los derechos de propiedad intelectual sobre el Servicio, incluyendo el software, diseño, logotipos y contenidos, son titularidad de BTOOLIN CONNECT S.L. Queda prohibida su reproducción, distribución o modificación sin autorización expresa.</p>

          <h2 style={S.h2}>7. Protección de datos</h2>
          <p style={S.p}>El tratamiento de datos personales se rige por nuestra Política de Privacidad, disponible en <strong style={{color:'rgba(255,255,255,0.85)'}}>https://gestavin.com/privacy</strong>, de conformidad con el Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica 3/2018 de Protección de Datos Personales (LOPDGDD).</p>

          <h2 style={S.h2}>8. Limitación de responsabilidad</h2>
          <p style={S.p}>BTOOLIN CONNECT S.L. no será responsable de los daños derivados de interrupciones del Servicio por causas ajenas a su control, del uso indebido del Servicio por parte del usuario, ni de la pérdida de datos causada por el usuario.</p>

          <h2 style={S.h2}>9. Modificaciones</h2>
          <p style={S.p}>BTOOLIN CONNECT S.L. se reserva el derecho de modificar estas Condiciones de Uso. Los cambios serán notificados por correo electrónico o mediante aviso en la plataforma con al menos 15 días de antelación.</p>

          <h2 style={S.h2}>10. Rescisión</h2>
          <p style={S.p}>El usuario podrá cancelar su suscripción en cualquier momento mediante comunicación a <strong style={{color:'rgba(255,255,255,0.85)'}}>info@gestavin.com</strong>. BTOOLIN CONNECT S.L. podrá suspender el acceso al Servicio en caso de incumplimiento de estas condiciones.</p>

          <h2 style={S.h2}>11. Legislación aplicable</h2>
          <p style={S.p}>Las presentes Condiciones se rigen por la legislación española. Para cualquier controversia, las partes se someten a los Juzgados y Tribunales de la ciudad de Barcelona, con renuncia expresa a cualquier otro fuero.</p>

          <h2 style={S.h2}>12. Contacto</h2>
          <p style={S.p}><strong style={{color:'rgba(255,255,255,0.85)'}}>BTOOLIN CONNECT S.L.</strong></p>
          <p style={S.p}>Correo electrónico: info@gestavin.com</p>
          <p style={S.p}>Sitio web: https://gestavin.com</p>

          <p style={S.foot}>BTOOLIN CONNECT S.L. · info@gestavin.com · gestavin.com</p>
        </div>
        <div style={{display:'flex', gap:'1.5rem', marginTop:24}}>
          <a href="/" style={S.back}>← Volver al inicio</a>
          <a href="/privacy" style={S.back}>Política de privacidad →</a>
        </div>
      </div>
    </div>
  );
}

// ── Verificación de email ─────────────────────────────────────────────────────

function VerificarEmailPage() {
  const [status, setStatus] = React.useState('loading'); // loading | ok | error
  const [msg,    setMsg]    = React.useState('');

  React.useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) { setStatus('error'); setMsg('Enlace inválido: falta el token.'); return; }

    fetch(`/api/auth/verify-email?token=${token}`)
      .then(r => r.json())
      .then(d => {
        if (d.ok) setStatus('ok');
        else { setStatus('error'); setMsg(d.error || 'Error desconocido'); }
      })
      .catch(() => { setStatus('error'); setMsg('Error de red'); });
  }, []);

  const icon  = status === 'loading' ? '⏳' : status === 'ok' ? '✅' : '❌';
  const title = status === 'loading' ? 'Verificando...'
              : status === 'ok'      ? '¡Cuenta verificada!'
              :                        'Error al verificar';
  const body  = status === 'loading' ? 'Por favor espera un momento.'
              : status === 'ok'      ? 'Tu cuenta ha sido activada correctamente. Ya puedes iniciar sesión.'
              :                        msg;
  const color = status === 'ok' ? '#15803d' : status === 'error' ? '#dc2626' : '#1e293b';

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#f8fafc', fontFamily:'inherit' }}>
      <div style={{ background:'#fff', borderRadius:16, padding:'40px 48px', textAlign:'center', boxShadow:'0 4px 24px rgba(0,0,0,.08)', maxWidth:420, width:'100%' }}>
        <div style={{ marginBottom:16 }}>
          <span style={{ fontFamily:"'DM Sans',sans-serif", fontWeight:300, fontSize:22, letterSpacing:'-1px' }}>
            <span style={{ color:'#E84300' }}>g</span>estavin
          </span>
        </div>
        <div style={{ fontSize:48, marginBottom:16 }}>{icon}</div>
        <h2 style={{ margin:'0 0 8px', color, fontSize:20 }}>{title}</h2>
        <p style={{ color:'#64748b', margin:'0 0 28px', fontSize:14 }}>{body}</p>
        {status !== 'loading' && (
          <a href="/" style={{ display:'inline-block', background:'#E84300', color:'#fff', padding:'10px 28px', borderRadius:8, textDecoration:'none', fontWeight:600, fontSize:14 }}>
            Ir al inicio de sesión
          </a>
        )}
      </div>
    </div>
  );
}

// ── Restablecer contraseña ────────────────────────────────────────────────────

function ResetPasswordPage() {
  const [status,   setStatus]   = React.useState('form'); // form | loading | ok | error
  const [password, setPassword] = React.useState('');
  const [confirm,  setConfirm]  = React.useState('');
  const [msg,      setMsg]      = React.useState('');
  const token = new URLSearchParams(window.location.search).get('token');

  async function handleSubmit(e) {
    e.preventDefault();
    if (!password || password.length < 6) { setMsg('La contraseña debe tener al menos 6 caracteres'); return; }
    if (password !== confirm) { setMsg('Las contraseñas no coinciden'); return; }
    setStatus('loading');
    try {
      const r = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const d = await r.json();
      if (d.ok) setStatus('ok');
      else { setMsg(d.error || 'Error desconocido'); setStatus('form'); }
    } catch {
      setMsg('Error de red'); setStatus('form');
    }
  }

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#f8fafc', fontFamily:'inherit' }}>
      <div style={{ background:'#fff', borderRadius:16, padding:'40px 48px', boxShadow:'0 4px 24px rgba(0,0,0,.08)', maxWidth:420, width:'100%' }}>
        <div style={{ marginBottom:24, textAlign:'center' }}>
          <span style={{ fontFamily:"'DM Sans',sans-serif", fontWeight:300, fontSize:22, letterSpacing:'-1px' }}>
            <span style={{ color:'#E84300' }}>g</span>estavin
          </span>
        </div>
        {status === 'ok' ? (
          <>
            <div style={{ fontSize:48, textAlign:'center', marginBottom:16 }}>✅</div>
            <h2 style={{ margin:'0 0 8px', color:'#15803d', fontSize:20, textAlign:'center' }}>¡Contraseña actualizada!</h2>
            <p style={{ color:'#64748b', fontSize:14, textAlign:'center', margin:'0 0 28px' }}>Ya puedes iniciar sesión con tu nueva contraseña.</p>
            <a href="/" style={{ display:'block', textAlign:'center', background:'#E84300', color:'#fff', padding:'10px 28px', borderRadius:8, textDecoration:'none', fontWeight:600, fontSize:14 }}>
              Ir al inicio de sesión
            </a>
          </>
        ) : (
          <>
            <h2 style={{ margin:'0 0 4px', fontSize:18, fontWeight:600 }}>Nueva contraseña</h2>
            <p style={{ color:'#64748b', fontSize:13, margin:'0 0 24px' }}>Introduce tu nueva contraseña para acceder a Gestavin.</p>
            {!token && <p style={{ color:'#dc2626', fontSize:13 }}>Enlace inválido.</p>}
            {token && (
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom:16 }}>
                  <label style={{ display:'block', fontSize:13, fontWeight:600, marginBottom:6, color:'#374151' }}>Nueva contraseña</label>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                    placeholder="Mínimo 6 caracteres" required
                    style={{ width:'100%', padding:'10px 12px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:14, boxSizing:'border-box' }} />
                </div>
                <div style={{ marginBottom:20 }}>
                  <label style={{ display:'block', fontSize:13, fontWeight:600, marginBottom:6, color:'#374151' }}>Confirmar contraseña</label>
                  <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                    placeholder="Repite la contraseña" required
                    style={{ width:'100%', padding:'10px 12px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:14, boxSizing:'border-box' }} />
                </div>
                {msg && <p style={{ color:'#dc2626', fontSize:13, margin:'0 0 12px' }}>{msg}</p>}
                <button type="submit" disabled={status === 'loading'}
                  style={{ width:'100%', background:'#E84300', color:'#fff', border:'none', borderRadius:8, padding:'11px', fontWeight:600, fontSize:14, cursor:'pointer' }}>
                  {status === 'loading' ? 'Guardando…' : 'Guardar contraseña'}
                </button>
              </form>
            )}
          </>
        )}
      </div>
    </div>
  );
}

// ── App principal ─────────────────────────────────────────────────────────────

export default function App() {
  // Persistir auth en sessionStorage para sobrevivir redirects OAuth
  const [auth, setAuth] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('crm_auth')) || null; }
    catch { return null; }
  });

  useEffect(() => {
    if (auth) sessionStorage.setItem('crm_auth', JSON.stringify(auth));
    else      sessionStorage.removeItem('crm_auth');
  }, [auth]);

  // Rutas públicas — no necesitan auth
  const path = window.location.pathname;
  if (path === '/installer' || path.startsWith('/installer/')) return <InstallerApp />;
  if (path === '/facebook/callback') return <FacebookCallbackPage />;
  if (path === '/verificar-email')   return <VerificarEmailPage />;
  if (path === '/reset-password')    return <ResetPasswordPage />;
  if (path === '/privacy')           return <PrivacyPage />;
  if (path === '/data-deletion')     return <DataDeletionPage />;
  if (path === '/terms')             return <TermsPage />;

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {!auth ? <Login /> : <Dashboard />}
    </AuthContext.Provider>
  );
}
